import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import './Dashboard';

const Dashboard = () => {
  return (
    <div className="AdminDashboard">
      <Helmet>
        <title>Admin Dashboard - Praktio</title>
      </Helmet>
      <div>Admin Dashboard</div>
      <div>
        <Link to="/admin/courses">Courses</Link>
      </div>
      <div>
        <Link to="/admin/teams">Teams</Link>
      </div>
      <div>
        <Link to="/admin/users">Users</Link>
      </div>
    </div>
  );
};

export default Dashboard;
